import React ,{useState} from 'react'
import axios from "axios";
import { APIURL,TZ } from "../../../Global";
import './profile.css'
import {Button ,Modal } from 'react-bootstrap';
import { useAlert } from 'react-alert';

function SplUpdate(props) {
    const[spl ,setSpl] =useState(props.spl !== '' ? props.spl : '')
    const alert = useAlert()
    const id = props.id1
    const [error,setError]=useState({
        spl:''
       });

    const handleChange=(e)=>{
        e.preventDefault();
        const val=e.target.value;  
        const key=e.target.name;
      
          if(key==='spl'){
            setSpl(val)
          }  
        }

        const  validate = () => {
          //let input = email;
          let errors = {};
          let isValid = true;
    
          if (spl==="" ) {
            isValid = false;
            errors["spl"] = "Enter specialization";
          }
      
          setError(currentstate=>({
            ...currentstate,...errors
          }))
      
          return isValid;
      }

      const handleContinue =async(e) => {
        e.preventDefault();
    
        if( validate() ){
          submitAddress()
        }
      }

        const submitAddress = (e) =>{
            const tokenString= sessionStorage.getItem('usertoken');
             
             let str= tokenString.replace(/["]+/g, '') 
          
             const data = {
                specialization : spl
             }
          
             axios.put(`${APIURL}/api/v1/doctor/medical-profile-update-view/${id}/` ,data, { headers: {
          
              "Authorization" : 'Token '+str  }})
            .then(res=>{
            
                  
              if(res.data.status==="success"){
                
                alert.success("Updated successfully")
                props.handle()
                setSpl()               
            
              }else{
                alert.error("Error in submission. Try again!") 
              }
            
            })
            .catch(err=>{
              alert.error("Error in submission. Try again!") 

            })
          
          }

          return (
        <div>
            <div className="item"><input className="form-control" type="text" value={spl} maxLength="150" name="spl" placeholder=" Super Speciality" onChange={handleChange}/>

                {error.spl ? <div className="error-validation-msg"> {error.spl}</div> : null}

            </div>
            <br/>
            <div className="form-button">
                <button  onClick={handleContinue} className="btn btn-primary btn-col" >Update Super Speciality</button>
            </div>            
        </div>
    )
}

export default SplUpdate
